import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchDispatchLog, type DispatchLogRow } from '../api-client';

export function useDispatchLog(
  campaignId: string,
  params?: { dispatch_id?: string; is_test?: boolean },
): { rows: DispatchLogRow[]; isLoading: boolean } {
  const { apiFetch } = useApi();
  const { data = [], isLoading } = useQuery({
    queryKey: ['launcher', 'campaigns', campaignId, 'dispatch-log', params],
    queryFn: () => fetchDispatchLog(apiFetch, campaignId, params),
    staleTime: 0,
    enabled: !!campaignId,
    refetchInterval: (query) => {
      const rows = query.state.data ?? [];
      return rows.some((r: DispatchLogRow) => r.result === 'queued' || r.result === 'processing') ? 2000 : false;
    },
  });
  return { rows: data, isLoading };
}
